export default "__VITE_ASSET__td6dF4RL__"